import { Line, LineColors } from './line';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class SatToSunLine extends Line {
    sat;
    constructor(sat) {
        super();
        this.sat = sat;
        this.color_ = LineColors.ORANGE;
    }
    update() {
        const eci = this.sat.eci(ServiceLocator.getTimeManager().simulationTimeObj);
        if (!eci) {
            this.isGarbage = true;
            return;
        }
        const eciArr = [eci.position.x, eci.position.y, eci.position.z];
        this.updateVertBuf([eciArr, ServiceLocator.getScene().sun.position]);
    }
}
